
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tug",
      function () {
        return require("private-next-pages/tug/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tug"])
      });
    }
  